import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { links } from "../../../../constants/links";

import { getSubCampaignRegister } from "../../../../services/ads/ads.service";

interface useSubcampaignProps {
    subCampaignId: string,
    qrscanlogId?: string,
}

export const useSubcampaign = ({ subCampaignId, qrscanlogId }: useSubcampaignProps) => {

    const location = useLocation();
    const initialData = location.state?.subcampaignData;

    const [data, setData] = useState<any>(initialData || null);
    const [isLoading, setIsLoading] = useState<boolean>(!initialData);
    const [isSubcampaignValid, setIsSubcampaignValid] = useState<boolean>(true);
    const [defaultLoginMethod, setDefaultLoginMethod] = useState<any>(initialData?.default_login_method || null);

    const navigate = useNavigate();

    useEffect(() => {

        if (!subCampaignId) {
            navigate(`${links.CAMPAIGN_STATUS.replace(":status", "error")}`);
            return;
        }

        const fetchSubCampaign = async () => {
            setIsLoading(true);
            getSubCampaignRegister(({ id: subCampaignId, qrSession: qrscanlogId })).then((data: any) => {
                setData((prevData: any) => ({ ...prevData, ...data }));
                if (data?.default_login_method) {
                    setDefaultLoginMethod(data?.default_login_method);
                }
                if (data?.advertiser_logo) {
                    localStorage.setItem("advertiser_logo", data.advertiser_logo);
                }
                if (Object.keys(data).length === 1) {
                    setIsSubcampaignValid(false);
                }
            }).catch((error: any) => {

                const errorResponse = error?.response?.data;
                const errorCode = errorResponse?.error_code;

                if (errorResponse) {
                    setData((prevData: any) => ({ ...prevData, ...errorResponse }));
                    if (errorCode === "engaged_limit_exceeded") {
                        return navigate(
                            links.CAMPAIGN_LIMIT_ERROR, {
                            state: {
                                advertiser_banner: errorResponse?.background,
                                banner_image_corner: errorResponse?.banner_image_corner
                            }
                        }
                        );
                    }
                }
                setIsSubcampaignValid(false);
            }).finally(() => {
                setIsLoading(false);
            });
        };

        fetchSubCampaign();

    }, [subCampaignId, navigate]);

    return { data, isLoading, isSubcampaignValid, defaultLoginMethod };
};
